import { render, staticRenderFns } from "./TeacherCard.vue?vue&type=template&id=12dc71f8&scoped=true&"
import script from "./TeacherCard.vue?vue&type=script&lang=js&"
export * from "./TeacherCard.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCard.vue?vue&type=style&index=0&id=12dc71f8&lang=scss&scoped=true&"
import style1 from "./TeacherCard.vue?vue&type=style&index=1&id=12dc71f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dc71f8",
  null
  
)

export default component.exports